// src/pages/AdminLogin.jsx
import {useEffect, useState} from "react";
import {useAuth} from "../Context/AuthContext";
import {useNavigate} from "react-router-dom";

export default function AdminLogin() {
    const { user,role,login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (user && role === "admin") {
            navigate(process.env.REACT_APP_ADMIN_ROUTE, { replace: true });
        }
    }, [user, role, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg("");

        try {
            await login(email, password);
        } catch (err) {
            setErrorMsg(err.message);
        }
    };

    return (
        <section className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
            <div className="w-full max-w-7xl">
                <div className="py-20 xl:py-40">
                    <div className="max-w-sm mx-auto">
                        <h3 className="font-heading text-4xl text-gray-900 font-semibold mb-4">
                            Login in to your account
                        </h3>
                        <p className="text-lg text-gray-500 mb-6">
                            Greetings on your return! We kindly request you to enter your details.
                        </p>

                        <form onSubmit={handleSubmit}>
                            {errorMsg && <p className="text-red-500 mb-4 text-sm">{errorMsg}</p>}

                            <div className="mb-6">
                                <label className="block mb-1.5 text-sm text-gray-900 font-semibold">Email</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Admin Email"
                                    className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                                    required
                                />
                            </div>

                            <div className="mb-7">
                                <label className="block mb-1.5 text-sm text-gray-900 font-semibold">Password</label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                                    required
                                />
                            </div>

                            <button
                                className="relative group block w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-orange-50 bg-orange-900 rounded-full overflow-hidden"
                                type="submit"
                            >
                                <div
                                    className="absolute top-0 right-full w-full h-full bg-gray-900 transform group-hover:translate-x-full group-hover:scale-102 transition duration-500"></div>
                                <span className="relative">Login</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>

    );
}
